// extracted by mini-css-extract-plugin
export var button = "styles-module--button--CldVE";
export var description = "styles-module--description--0J4me";
export var image = "styles-module--image--Y2EPz";
export var product = "styles-module--product--0WCau";
export var productsContainer = "styles-module--productsContainer--6dsko";